import Rellax from 'rellax/rellax'
import HomeEnum from '../../enumerators/home.enum'

export default class AnimationsComponent {
    constructor() {
        AnimationsComponent.initParallax()
        AnimationsComponent.initScrollReveal()
    }

    static initParallax() {
        if (window.matchMedia('(min-width: 1001px)').matches) {
            const rellax = new Rellax(HomeEnum.PARALLAX_ITEM, {
                speed: 1,
                center: true,
            })
        }
    }

    static initScrollReveal() {
        const revealElement = '[data-trigger="scroll-observer"]'
        const ratio = 0.1
        const options = {
            root: null,
            rootMargin: window.matchMedia('(max-width: 1000px)').matches ? '-10px' : '-80px',
            threshold: 0.1,
        }

        const handleIntersect = (entries, observer) => {
            entries.forEach((entry) => {
                if (entry.intersectionRatio >= ratio) {
                    entry.target.classList.add('reveal')
                    observer.unobserve(entry.target)
                }
            })
        }

        const observer = new IntersectionObserver(handleIntersect, options)
        document.querySelectorAll(revealElement).forEach((el) => {
            observer.observe(el)
        })
    }
}
